// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "@revvsales/components";

// Action Imports
import { AssetActions } from "../../../../actions";

// Internal Imports
import { EVENTS } from "../../../../constants";
import { AmplitudeUtils } from "../../../../utils";

// Destructuring
const { moveToAssetItemsAction } = AssetActions;
const { amplitudeLogEvent } = AmplitudeUtils;

class AssetCustomizeColumnPopup extends Component {
  state = {
    assetColumns: [],
    showButtunLoader: false,
  };

  componentDidMount() {
    const filterColumns = this.props.assetColumns
      ? this.props.assetColumns.filter(
          column => column.id !== "title" || column.id !== "contact",
        )
      : [];
    this.setState({
      assetColumns: filterColumns,
    });
  }

  _closePopup = () => {
    this.props.closePopup("showCustomizeColumnPopup", false);
  };

  _createFolderHandler = () => {
    this.setState({ showButtunLoader: true });
    const { associatedFolderId } = this.props;
    const payload = {
      name: this.state.folderName,
      parent_id: associatedFolderId || null,
    };
    this.props
      .createAssetFolder(payload)
      .then(response => {
        const { id, name } = response.folder;
        this.setState({ showButtunLoader: false });
        const redirectUrl = this._getAssetFolderUrl(id, name);
        amplitudeLogEvent(EVENTS.EVENT_NAMES.FOLDER_CREATED, {
          folderId: id,
        });
        this.props.history.push(redirectUrl);
        this._closePopup();
      })
      .catch(error => {
        console.error(
          `CreateAssetFolderPopup => _createFolderHandler => Error : ${error}`,
        );
        this.setState({
          showButtunLoader: false,
        });
      });
  };

  _toggleColumnIsActive = columnId => {
    const { assetColumns } = this.state;
    const newColumns = assetColumns.map(column => {
      if (column.id === columnId) {
        return {
          ...column,
          isActive: !column.isActive,
        };
      }
      return column;
    });

    this.setState({
      assetColumns: newColumns,
    });
  };

  _dragStart = e => {
    //
    this.dragged = e.currentTarget;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", this.dragged);
  };

  _dragEnd = () => {
    const { assetColumns } = this.state;
    const data = [...assetColumns];
    const from = Number(this.dragged.dataset.id);
    const to = Number(this.over.dataset.id);
    if (!Number.isNaN(from) && !Number.isNaN(to)) {
      const temp = data[from];
      data[from] = data[to];
      data[to] = temp;
      this.setState({ assetColumns: data });
    }
  };

  _dragOver = e => {
    //
    e.preventDefault();
    this.over = e.target;
  };

  _getColumns = () => {
    const { assetColumns } = this.state;
    return assetColumns.map((column, index) => (
      <div
        draggable="true"
        data-id={index}
        onDragStart={this._dragStart}
        onDragEnd={this._dragEnd}
        className="assetcustomizecolumnpopup-row"
        key={column.id}>
        <div data-id={index} className="assetcustomizecolumnpopup-col">
          <FontAwesomeIcon
            icon={["far", "bars"]}
            data-id={index}
            className="assetcustomizecolumnpopup-col-icon"
            draggable="true"
            onDragStart={this._dragStart}
            onDragEnd={this._dragEnd}
          />
          <span data-id={index} className="assetcustomizecolumnpopup-col-label">
            {column.label}
          </span>
        </div>
        <div className="assetcustomizecolumnpopup-col">
          <Input
            checked={column.isActive}
            id={`assetcolumn-${column.id}`}
            isSwitch
            type="checkbox"
            onChange={() => this._toggleColumnIsActive(column.id)}
            data-test="assetcustomizecolumnpopup-input"
          />
        </div>
      </div>
    ));
  };

  _modifyAssetColumns = () => {
    const { assetColumns } = this.state;
    this.props.setAssetColumnChanges(assetColumns);
    this._closePopup();
  };

  render() {
    const { showButtunLoader } = this.state;
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="assetcustomizecolumnpopup-container"
          data-test="assetcustomizecolumnpopup-container">
          {/* ---------- Modal Heading Section ---------- */}
          <div
            className="assetcustomizecolumnpopup-modal-heading"
            data-test="assetcustomizecolumnpopup-modal-heading">
            Customize columns
          </div>
        </div>

        <div
          onDragOver={this._dragOver}
          className="assetcustomizecolumnpopup-columns-wrapper">
          {this._getColumns()}
        </div>

        {/* ---------- Action Buttons Section ---------- */}
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="assetmovetofolder-movetofolder-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              data-test="assetmovetofolder-movetofolder-button"
              onClick={this._modifyAssetColumns}
              isLoading={showButtunLoader}>
              Save
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  moveToAssetItems: moveToAssetItemsAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(AssetCustomizeColumnPopup);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetCustomizeColumnPopup/index.js